module.exports = __webpack_public_path__ + "img/news_background.ba214c86.svg";